// extracted by mini-css-extract-plugin
module.exports = {"codeBlock":"CodeBlock_codeBlock__YIqLo","clickableCodeBlock":"CodeBlock_clickableCodeBlock__7nEhh"};